<div class="custom-dialog">
    <div class="modal-blue-icon modal-icon">
      <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23 0.5C35.4263 0.5 45.5 10.5736 45.5 23C45.5 35.4263 35.4263 45.5 23 45.5C10.5736 45.5 0.5 35.4263 0.5 23C0.5 10.5736 10.5736 0.5 23 0.5ZM28.5 14.5H17.5C16.3954 14.5 15.5 15.3954 15.5 16.5V29.5C15.5 30.6046 16.3954 31.5 17.5 31.5H28.5C29.6046 31.5 30.5 30.6046 30.5 29.5V16.5C30.5 15.3954 29.6046 14.5 28.5 14.5ZM22.5 25.5V28H20.5V25.5H17.5V23.5H20.5V21H22.5V23.5H25.5V25.5H22.5Z"
          fill="white" />
      </svg>
    </div>
  
    <div class="modal-title">Resolve by First Aid Confirmation</div>
    <div class="modal-text">Are you sure you want to resolve this issue through the First Aid team? Please provide remarks for resolution.</div>
  
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <form [formGroup]="resolveByFirstAidForm">
          <div class="form-group">
            <textarea
              class="form-control"
              id="remarksTextarea"
              formControlName="remarks"
              rows="4"
              placeholder="Enter remarks"
            ></textarea>
            <!-- Validation message -->
            <div
              class="text-danger"
              *ngIf="submitted && resolveByFirstAidForm.controls['remarks'].invalid"
            >
              Please provide remarks before proceeding.
            </div>
          </div>
        </form>
      </div>
    </div>
  
    <div class="text-center">
      <button class="btn btn-secondary" (click)="cancel()">CANCEL</button>
      <button class="btn btn-brand ml-3" (click)="resolveByFirstAid()">RESOLVE</button>
    </div>
  </div>
  